<template>
    <!--@formatter:off-->
    <div>
        <div class="tit_q_input">
            <strong class="tit">{{$t('SurveyQuestionEditorParentCounselWeek_counselTime')}}<span class="txt">{{$t('common_fcfs')}}</span></strong>
        </div>
        <div class="q_input" :id="`questionEditor${questionNo}`">
            <ul>
                <li>
                    <div class="info_lbl">{{$t('SurveyQuestionEditor_questionNumber', {number: questionNumber})}}</div>
                    <div class="info_txt">
                        <div class="bx_input_wrap">
                            <TextArea
                                ref="inputQuestion"
                                :id="`q${questionNo}`"
                                :placeholder="$t('SurveyQuestionEditor_inputQuestion')"
                                :maxlength="300"
                                cols="50"
                                rows="1"
                                label-class="input_lbl"
                                label-tag="label"
                                :resize="true"
                                v-model="questionText"
                            />
                            <ul class="b_area">
                                <li>
                                    <ImageUpload v-slot="{openFileDialog}" v-on:requestUpload="uploadImage">
                                        <button type="button" class="btn" @click.prevent="openFileDialog">{{$t('SurveyQuestionEditor_attachImage')}}</button>
                                    </ImageUpload>
                                </li>
                                <li>
                                    <span class="bx_input_chk bx_chk_req">
                                        <input type="checkbox" class="input_chk" :id="`req${questionNo}`" v-model="mandatory">
                                        <label :for="`req${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditor_setMandatory')}}</label>
                                    </span>
                                </li>
                            </ul>
                        </div>
                    </div>
                    <div class="bx_include_file" v-if="showImage">
                        <div class="image">
                            <img :src="image.url" alt="" style="max-width: 100%">
                            <button type="button" class="btn_delete" v-on:click.prevent="deleteImage(questionNo)"><span class="sp">{{$t('SurveyQuestionEditor_deleteImage')}}</span></button>
                        </div>
                    </div>
                </li>
                <li class="time">
                    <div class="info_lbl">{{$t('SurveyQuestionEditorParentCounselWeekTime_timeTableSettings')}}</div>
                    <div class="info_until">
                        <span class="tit">{{$t('SurveyQuestionEditorParentCounselWeekTime_counselPeriod')}}</span>
                        <CustomSelect
                            class="bx_sorting3"
                            :options="selectOptions.counselPeriod"
                            v-model="counselPeriodCount"
                            v-ga-helper:input.vueEvent="gaCounselPeriod"
                        />

                        <span class="tit">{{$t('SurveyQuestionEditorParentCounselWeekTime_counselTimeSlotCount')}}</span>
                        <CustomSelect
                            class="bx_sorting3"
                            :options="selectOptions.counselTimeSlotCount"
                            :input-props="inputOptions.counselTimeSlotCount"
                            v-model="innerCounselTimeSlotCount"
                            v-ga-helper:input.vueEvent="gaCounselTime"
                        />

                        <span class="tit">{{$t('SurveyQuestionEditorParentCounselWeekTime_personPerTime')}}</span>
                        <em class="num">{{$t('SurveyQuestionEditorParentCounselWeekTime_personPerTime_1')}}</em>
                    </div>

                    <div class="area_time">
                        <div class="box_time"  ref="boxTime" style="overflow-x: scroll">
                            <button type="button" class="btn_add time sp" @click="addCounselTimeSlot"><span class="blind">{{$t('SurveyQuestionEditorParentCounselWeekTime_addTime')}}</span></button>
                            <table class="tbl_time" :class="{'data10': counselPeriodCount >= 10}"  style="width: auto; min-width: 100%; position:relative">
                                <thead>
                                <tr>
                                    <th></th>
                                    <th
                                        v-for="(day, dayIndex) in counselPeriods"
                                        :key="`day-${day.id}`"
                                    >
                                        <button
                                            type="button"
                                            class="btn_del sp"
                                            :disabled="counselPeriodCount < 2"
                                            @click="removeCounselPeriod(dayIndex)"
                                        >
                                            <span class="blind">{{$t('SurveyQuestionEditorParentCounselWeekTime_deleteDay')}}</span>
                                        </button>
                                        <div class="date">
                                            <div class="tui-datepicker-input tui-datetime-input tui-has-focus">
                                                <input type="text" :id="`datepicker-input-${dayIndex}`" aria-label="Date-Time" readonly>
                                                <div :id="`datepicker-container-${dayIndex}`" class="tui-datepicker_calendar"></div>
                                            </div>
                                        </div>
                                    </th>
                                </tr>
                                </thead>
                                <tbody>
                                <tr
                                    v-for="(timeSlot, timeSlotIndex) in counselTimeSlots"
                                    :key="`timeSlot-${timeSlotIndex}`"
                                >
                                    <th style="white-space: nowrap">
                                        <button
                                            type="button"
                                            class="btn_del sp"
                                            :disabled="counselTimeSlotCount < 2"
                                            @click="removeCounselTimeSlot(timeSlotIndex)"
                                        >
                                            <span class="blind">{{$t('SurveyQuestionEditorParentCounselWeekTime_deleteTime')}}</span>
                                        </button>
                                        <div class="time">
                                            <input
                                                type="text"
                                                :id="`time-slot-${timeSlotIndex}`"
                                                :placeholder="$t('SurveyQuestionEditorParentCounselWeekTime_inputTime')"
                                                maxlength="11"
                                                :value="timeSlot"
                                                @input="setCounselTimeSlotValue({index: timeSlotIndex, value: $event.target.value})"
                                            >
                                        </div>
                                    </th>
                                    <td
                                        v-for="(day, periodIndex) in counselPeriods"
                                        :key="`time-${periodIndex}-${timeSlotIndex}`"
                                    >
                                        <div class="inner_cell">
                                            <button
                                                type="button"
                                                :class="{
                                                    'btn_impossible': !counselTimes[periodIndex][timeSlotIndex].value,
                                                    'btn_possible': counselTimes[periodIndex][timeSlotIndex].value
                                                }"
                                                @click="toggleCounselTimeValue({periodIndex, timeSlotIndex})"
                                            >
                                                <span class="blind">
                                                    <template v-if="counselTimes[periodIndex][timeSlotIndex].value">
                                                        {{$t('SurveyQuestionEditorParentCounselWeekTime_counselPossible')}}
                                                    </template>
                                                    <template v-else>
                                                        {{$t('SurveyQuestionEditorParentCounselWeekTime_counselImpossible')}}
                                                    </template>
                                                </span>
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                                </tbody>
                                <button type="button" class="btn_add date sp" @click="addCounselPeriod" v-if="counselPeriodCount < 30" style="right: -27px"><span class="blind">{{$t('SurveyQuestionEditorParentCounselWeekTime_addDay')}}</span></button>
                            </table>
                        </div>
                        <div class="noti_time">
                            <p class="desc_noti" v-html="$t('SurveyQuestionEditorParentCounselWeekTime_counselTimeDesc')"></p>
                            <ul class="list_noti">
                                <li class="possible txt_color">{{$t('SurveyQuestionEditorParentCounselWeekTime_counselPossible')}}</li>
                                <li class="impossible">{{$t('SurveyQuestionEditorParentCounselWeekTime_counselImpossible')}}</li>
                            </ul>
                        </div>
                    </div>
                </li>
                <li class="ex_sel">
                    <div class="info_lbl">{{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeOption')}}</div>
                    <div class="info_select">
                        <span class="bx_input_rdo">
                            <input
                                type="radio"
                                class="input_rdo"
                                :id="`no-time-1-${questionNo}`"
                                :value="PARENT_COUNSEL_WEEK_NO_TIME_OPTION.USE_TEXT"
                                v-model="noTimeOption"
                                v-ga-helper:change="{
                                    view_category: '설문리스트(상담시간)',
                                    view_area: '상담가능시간없음선택옵션클릭',
                                    view_label: '사용(기타주관식질문추가)',
                                }"
                            >
                            <label :for="`no-time-1-${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeOption_useText')}}</label>
                        </span>
                        <span class="bx_input_rdo">
                            <input
                                type="radio"
                                class="input_rdo"
                                :id="`no-time-2-${questionNo}`"
                                :value="PARENT_COUNSEL_WEEK_NO_TIME_OPTION.USE_NO_TEXT"
                                v-model="noTimeOption"
                                v-ga-helper:change="{
                                    view_category: '설문리스트(상담시간)',
                                    view_area: '상담가능시간없음선택옵션클릭',
                                    view_label: '사용(주관식질문추가하지않음)',
                                }"
                            >
                            <label :for="`no-time-2-${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeOption_useNoText')}}</label>
                        </span>
                        <span class="bx_input_rdo">
                            <input
                                type="radio"
                                class="input_rdo"
                                :id="`no-time-3-${questionNo}`"
                                :value="PARENT_COUNSEL_WEEK_NO_TIME_OPTION.NOT_USE"
                                v-model="noTimeOption"
                                v-ga-helper:change="{
                                    view_category: '설문리스트(상담시간)',
                                    view_area: '상담가능시간없음선택옵션클릭',
                                    view_label: '사용안함',
                                }"
                            >
                            <label :for="`no-time-3-${questionNo}`" class="input_lbl">{{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeOption_notUse')}}</label>
                        </span>
                    </div>
                </li>
            </ul>
        </div>
        <SurveyQuestionEditor
            v-if="noTimeOption === PARENT_COUNSEL_WEEK_NO_TIME_OPTION.USE_TEXT"
            :question="noTimeQuestion"
            :is-use-start-question-number="false"
            :question-index="0"
            :siblings-count="0"
            :parent-question-number="questionNumber"
            :is-show-question-desc="false"
            :is-show-type="false"
            :is-show-operation="false"
        >
            <template v-slot:innerHeader>
                <div class="sub_select">
                    {{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeQuestionCondition', {n: questionNumber})}}
                </div>
                <div class="tit_q_input">
                    <strong class="tit">{{$t('SurveyQuestionEditorParentCounselWeekTime_noTimeQuestionTime')}}<span class="txt">{{$t('SurveyQuestionEditor_subjective')}}</span></strong>
                </div>
            </template>
        </SurveyQuestionEditor>
    </div>
    <!--@formatter:on-->
</template>

<script>
import TUIDatePicker from "tui-date-picker";
import TextArea from '@iamteacherpc/components/common/TextArea.vue';
import SurveyQuestionEditor from '@iamteacherpc/components/editor/SurveyQuestionEditor.vue';
import {createNamespacedHelpers} from 'vuex';
import {NAMESPACE} from '@common/store/modules/survey/editor.js';
import {FORMAT_MONTH_DATE_DAY_FOR_DATEPICKER, toMonthDateDayFormat} from '@common/utils/date.js';
import {
    ADD_QUESTION_COUNSEL_PERIOD,
    ADD_QUESTION_COUNSEL_TIME_SLOT,
    GET_QUESTION_COUNSEL_PERIOD_RESET_DATES,
    MAX_COUNSEL_PERIOD,
    MAX_COUNSEL_TIME_SLOT,
    REMOVE_QUESTION_COUNSEL_PERIOD,
    REMOVE_QUESTION_COUNSEL_TIME_SLOT,
    SET_QUESTION_COUNSEL_NO_TIME_OPTION,
    SET_QUESTION_COUNSEL_PERIOD_COUNT,
    SET_QUESTION_COUNSEL_PERIOD_VALUE,
    SET_QUESTION_COUNSEL_TIME_SLOT_COUNT,
    SET_QUESTION_COUNSEL_TIME_SLOT_VALUE,
    SET_QUESTION_COUNSEL_TIME_VALUE,
} from '@common/store/modules/common/editor/parentCounselWeek.js';
import {requestAlert, requestConfirm} from '@iamteacherpc/utils/iframe.js';
import {PARENT_COUNSEL_WEEK_NO_TIME_OPTION} from '@common/consts/survey.js';

const {mapActions} = createNamespacedHelpers(NAMESPACE);

export default {
    name: "SurveyQuestionEditorParentCounselWeekTime",
    extends: SurveyQuestionEditor,
    components: {SurveyQuestionEditor, TextArea},

    props: {
        question: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            innerCounselTimeSlotCount: 0,
        }
    },

    computed: {
        selectOptions() {
            const counselPeriod = [];

            for (let i = 1; i <= MAX_COUNSEL_PERIOD; i++) {
                counselPeriod.push({
                    label: this.$t('SurveyQuestionEditorParentCounselWeekTime_nDay', {n: i}),
                    value: i,
                });
            }

            const counselTimeSlotCount = [];

            for (let i = 1; i <= MAX_COUNSEL_TIME_SLOT; i++) {
                counselTimeSlotCount.push({
                    label: this.$t('common_count', {count: i}),
                    value: i,
                });
            }

            return {
                counselPeriod,
                counselTimeSlotCount,
            }
        },

        inputOptions() {
            return {
                counselTimeSlotCount: {
                    id: `counsel-time-slot-count${this.questionIndex}`,
                    onlyNumber: true,
                    maxLength: 2,
                    placeholder: this.$t('common_inputBySelf'),
                },
            }
        },

        counselPeriodCount: {
            get() {
                return this.question.counselPeriods.length;
            },
            set(count) {
                const prevCount = this.counselPeriodCount;
                this[SET_QUESTION_COUNSEL_PERIOD_COUNT]({question: this.question, count});

                if (count < prevCount) {
                    for (let i = count; i < this.datepickers.length; i++) {
                        this.datepickers[i].destroy();
                    }
                    this.datepickers = this.datepickers.slice(0, count);
                    return;
                }

                // async/await 사용 시 warn 발생
                this.$nextTick(() => {
                    const diff = count - prevCount;
                    for (let i = 0; i < diff; i++) {
                        this.addDatePicker();
                    }
                });
            },
        },

        counselPeriods() {
            return this.question.counselPeriods;
        },

        counselTimeSlotCount: {
            get() {
                return this.question.counselTimeSlots.length;
            },
            set(value) {
                if (!value) {
                    return;
                }
                this[SET_QUESTION_COUNSEL_TIME_SLOT_COUNT]({question: this.question, count: value});
            },
        },

        counselTimeSlots() {
            return this.question.counselTimeSlots;
        },

        counselTimes() {
            return this.question.counselTimes;
        },

        noTimeOption: {
            get() {
                return this.question.noTimeOption;
            },
            set(noTimeOption) {
                this[SET_QUESTION_COUNSEL_NO_TIME_OPTION]({question: this.question, noTimeOption});
            },
        },

        noTimeQuestion() {
            return this.question.questions[0];
        },

        PARENT_COUNSEL_WEEK_NO_TIME_OPTION() {
            return PARENT_COUNSEL_WEEK_NO_TIME_OPTION;
        },
    },

    watch: {
        innerCounselTimeSlotCount(value) {
            this.counselTimeSlotCount = value;
        },

        counselTimeSlotCount(value) {
            this.innerCounselTimeSlotCount = value;
        },

        async noTimeOption(value) {
            if (value === PARENT_COUNSEL_WEEK_NO_TIME_OPTION.NOT_USE) {
                this.stopListChange();
                await requestAlert({
                    title: this.$t('SurveyQuestionEditorParentCounselWeekTime_noTimeOption_notUse_alert'),
                    okText: this.$t('common_confirm'),
                });
                this.listChange();
            }
        },
    },

    methods: {
        ...mapActions([
            ADD_QUESTION_COUNSEL_PERIOD,
            REMOVE_QUESTION_COUNSEL_PERIOD,
            SET_QUESTION_COUNSEL_PERIOD_COUNT,
            ADD_QUESTION_COUNSEL_TIME_SLOT,
            REMOVE_QUESTION_COUNSEL_TIME_SLOT,
            SET_QUESTION_COUNSEL_TIME_SLOT_COUNT,
            SET_QUESTION_COUNSEL_TIME_SLOT_VALUE,
            SET_QUESTION_COUNSEL_TIME_VALUE,
            SET_QUESTION_COUNSEL_PERIOD_VALUE,
            GET_QUESTION_COUNSEL_PERIOD_RESET_DATES,
            SET_QUESTION_COUNSEL_NO_TIME_OPTION,
        ]),

        async addCounselPeriod() {
            if (this.question.counselPeriods.length >= MAX_COUNSEL_PERIOD) {
                this.stopListChange();
                await requestAlert({
                    title: this.$t('SurveyQuestionEditorParentCounselWeekTime_maxPeriod', {
                        n: MAX_COUNSEL_PERIOD,
                    }),
                    okText: this.$t('common_confirm'),
                });
                this.listChange();
                return;
            }

            this[ADD_QUESTION_COUNSEL_PERIOD]({question: this.question});
            await this.$nextTick();
            this.addDatePicker();
            this.$refs.boxTime.scrollLeft = this.$refs.boxTime.scrollWidth - this.$refs.boxTime.clientWidth; // 시간표 스크롤을 가장 오른쪽으로 이동
        },

        removeCounselPeriod(index) {
            this[REMOVE_QUESTION_COUNSEL_PERIOD]({question: this.question, index});
            this.removeDatePicker(index);
        },

        async addCounselTimeSlot() {
            if (this.question.counselTimeSlots.length >= MAX_COUNSEL_TIME_SLOT) {
                this.stopListChange();
                await requestAlert({
                    title: this.$t('SurveyQuestionEditorParentCounselWeekTime_maxTimeSlot', {
                        n: MAX_COUNSEL_TIME_SLOT,
                    }),
                    okText: this.$t('common_confirm'),
                });
                this.listChange();
                return;
            }

            this[ADD_QUESTION_COUNSEL_TIME_SLOT]({question: this.question});
        },

        removeCounselTimeSlot(index) {
            this[REMOVE_QUESTION_COUNSEL_TIME_SLOT]({question: this.question, index});
        },

        setCounselTimeSlotValue({index, value}) {
            this[SET_QUESTION_COUNSEL_TIME_SLOT_VALUE]({question: this.question, index, value});
        },

        toggleCounselTimeValue({periodIndex, timeSlotIndex}) {
            let value = this.counselTimes[periodIndex][timeSlotIndex].value ? 0 : 1;
            this[SET_QUESTION_COUNSEL_TIME_VALUE]({
                question: this.question,
                periodIndex,
                timeSlotIndex,
                value,
            });
        },

        addDatePicker() {
            const index = this.datepickers.length;
            const datepicker = new TUIDatePicker(this.$el.querySelector(`#datepicker-container-${index}`), {
                date: this.counselPeriods[index].value,
                language: this.$i18n.locale,
                selectableRanges: [
                    [new Date(), new Date(2099, 12, 31)],
                ],
                input: {
                    element: this.$el.querySelector(`#datepicker-input-${index}`),
                    format: FORMAT_MONTH_DATE_DAY_FOR_DATEPICKER[this.$i18n.locale],
                },
            });

            datepicker.periodIndex = index;
            datepicker.isChangeListenerOn = true;

            const onChange = async () => {
                if (!datepicker.isChangeListenerOn) {
                    return;
                }

                let isResetDate = false;
                let resetDates;

                if (datepicker.periodIndex === 0 && this.counselPeriods.length > 1) {
                    try {
                        resetDates = await this[GET_QUESTION_COUNSEL_PERIOD_RESET_DATES]({
                            question: this.question,
                            startDate: datepicker.getDate(),
                        });

                        const startDateText = toMonthDateDayFormat(resetDates[0]);
                        const endDateText = toMonthDateDayFormat(resetDates[resetDates.length - 1]);

                        this.stopListChange();
                        const desc = this.$t('SurveyQuestionEditorParentCounselWeekTime_confirmAutoDateDesc', {
                            startDate: startDateText,
                            endDate: endDateText,
                        });

                        await requestConfirm({
                            title: this.$t('SurveyQuestionEditorParentCounselWeekTime_confirmAutoDate'),
                            desc,
                            descHtml: `<span class="txt_color type2">${desc}</span>`,
                            okText: this.$t('common_change'),
                            cancelText: this.$t('common_cancel'),
                        });

                        isResetDate = true;
                    } catch (e) {
                        if (e) {
                            throw e;
                        }
                    } finally {
                        this.listChange();
                    }
                }

                if (isResetDate) {
                    for (let i = 0; i < this.counselPeriods.length; i++) {
                        this[SET_QUESTION_COUNSEL_PERIOD_VALUE]({
                            question: this.question,
                            index: i,
                            value: resetDates[i],
                        });

                        this.datepickers[i].isChangeListenerOn = false;
                        this.datepickers[i].setDate(resetDates[i]);
                        this.datepickers[i].isChangeListenerOn = true;
                    }
                } else {
                    this[SET_QUESTION_COUNSEL_PERIOD_VALUE]({
                        question: this.question,
                        index: datepicker.periodIndex,
                        value: datepicker.getDate(),
                    });
                }
            }

            datepicker.on('change', onChange);
            datepicker.on('open', this.onOpenDatepicker);

            this.datepickers.push(datepicker);
        },

        async removeDatePicker(index) {
            this.datepickers[index].destroy();
            this.datepickers.splice(index, 1);

            await this.$nextTick();

            for (let i = index/* 삭제했기 때문에 다음 index가 1 당겨진다 */; i < this.datepickers.length; i++) {
                this.datepickers[i].periodIndex = i;
            }
        },

        /**
         * 데이트 피커의 가로 위치를 영역 안에 들어오도록 조정한다.
         * 이 함수는 그 역할 상 어쩔 수 없이 마크업 구조에 매우 디펜던시를 가진다.
         */
        onOpenDatepicker() {
            const questionWidth = this.$el.clientWidth;
            const container = [...this.$el.querySelectorAll('.tui-datepicker')].find(el => el.style.display === 'block');
            const positionAncestor = container.closest('.date');
            const left = positionAncestor.offsetLeft + 33;
            const width = container.offsetWidth;
            const right = left + width;
            const diff = questionWidth - right;

            if (diff < 0) {
                container.style.right = '-1px';
                container.style.left = 'auto';
            } else {
                container.style.left = '-1px';
                container.style.right = 'auto';
            }
        },

        initDatePicker() {
            this.datepickers = [];
            for (let i = 0; i < this.counselPeriods.length; i++) {
                this.addDatePicker();
            }
        },

        gaCounselPeriod($event) {
            return {
                view_category: '설문리스트(상담시간)',
                view_area: '상담기간클릭',
                view_label: this.selectOptions.counselPeriod.find(option => option.value === $event).label,
            }
        },

        gaCounselTime($event) {
            return {
                view_category: '설문리스트(상담시간)',
                view_area: '상담시간대클릭',
                view_label: this.selectOptions.counselTimeSlotCount.find(option => option.value === $event).label,
            }
        },
    },

    created() {
        this.innerCounselTimeSlotCount = this.counselTimeSlotCount;
    },

    mounted() {
        this.initDatePicker();
    },

    beforeDestroy() {
        this.datepickers.forEach(datepicker => {
            datepicker.destroy();
        });
    },
}
</script>

<style scoped>
</style>
